import styled from "styled-components";
import { v, b, t } from "../styles/variables";

export const LayoutMain = styled.main`
	transition: ${t.fastSp};
	padding: ${v.mediumDist} ${v.mediumDist} ${v.mediumDist};

	@media ${b.medium} {
		padding: ${v.mediumDist} ${v.xLargeDist} ${v.mediumDist};
	}

	@media ${b.large} {
		padding: ${v.mediumDist} ${v.xxLargeDist} 0;
	}
`;
